import { apiClient } from 'api/apiClient';
import type { TWarehouse } from 'legacy/lib/api/types/Warehouse';

const RESOURCE = '/addresses';

export const getWarehouses = async (filter?: string): Promise<TWarehouse[]> => {
	const { data } = await apiClient.get(`${RESOURCE}${filter}`);
	return data;
};
